<template>
  <div>
    <div class="search-main">
      <Form
        ref="searchForm"
        :model="formInline"
        label-position="right"
        :label-width="0"
        inline
        style="position: relative; margin-bottom: 10px"
        class="search-list-430 search-wrapper-430"
      >
        <FormItem label="">
          <Input
            v-model="orderNumValue"
            placeholder="请输入"
            clearable
            class="search-selectInput-430"
          >
            <Select
              slot="prepend"
              v-model="orderNumSelectValue"
              placeholder="请选择"
              class="search-select-430"
            >
              <Option value="1">订单编号</Option><Option value="2">交易流水号</Option>
            </Select></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="offerValue"
            placeholder="请输入"
            clearable
            class="search-selectInput-430"
          >
            <Select
              slot="prepend"
              v-model="offerSelectValue"
              placeholder="请选择"
              class="search-select-430"
            >
              <Option value="1">材料名称</Option><Option value="2">材料ID</Option>
            </Select></Input>
        </FormItem>

        <FormItem label="">
          <ChooseApply
            v-if="portOrg != 2"
            ref="chooseSchoolRef"
            :placeholder="`请选择学校`"
            :year-term-code="[formInline.yearCode, formInline.termCode]"
            :clearable="true"
            :org-type="`1`"
          ></ChooseApply>
          <p v-else>{{ userInfo && userInfo.orgName }}</p>
        </FormItem>
        <FormItem label="">
          <ChooseApply
            v-if="portOrg != 3"
            ref="chooseApplyRef"
            :placeholder="`请选择机构`"
            :year-term-code="[formInline.yearCode, formInline.termCode]"
            :clearable="true"
            :org-type="``"
          ></ChooseApply>
          <p v-else>{{ userInfo && userInfo.orgName }}</p>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="formInline.studentName"
            type="text"
            placeholder="学生姓名"
            class="search-input-430"
            clearable
          >
          </Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="formInline.parentPhone"
            type="text"
            placeholder="请输入家长手机"
            class="search-input-430"
            clearable
          >
          </Input>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="formInline.paySts"
            placeholder="请选择订单状态"
            class="search-select-430"
          >
            <Option value="0">待支付</Option>
            <Option value="1">支付成功</Option>
            <Option value="2">已关闭</Option>
            <Option value="8">费用补缴</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :placeholder="`请选择学期`"
            :cache-year-terms="initYear"
            @on-init="handleSearch"
            @on-change="onCascaderChange"
          ></CascaderYearTerms>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="formInline.classroomName"
            type="text"
            placeholder="请输入关联商品名称"
            class="search-input-430"
            clearable
          >
          </Input>
        </FormItem>

        <FormItem label="">
          <DatePicker
            type="datetimerange"
            class="dateTimeRange-430"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择开始时间 - 结束时间"
            :transfer="true"
            @on-change="onDateChange"
          ></DatePicker>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="formInline.ordTypes"
            placeholder="请选择购买方式"
            class="search-select-430"
          >
            <Option value="0">购买方式</Option>
            <Option value="5">单独购买材料费</Option>
            <Option value="1,3">与课程商品合并购买</Option>
          </Select>
        </FormItem>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="search-430" @click="handleReset">重置</Button>
      </Form>

      <!-- <div class="action-main flex justify-content_end">
        <Button @click="handleExport" type="primary">导出Excel</Button>
      </div> -->
    </div>
  </div>
</template>

<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';

import ChooseApply from '@c/searchBlock/ChooseApply.vue';
export default {
  components: {
    CascaderYearTerms,
    ChooseApply
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      portOrg: Number(localStorage.getItem('portOrg')),
      orderNumValue: '',
      orderNumSelectValue: '1',
      initYear: [],
      offerValue: '',
      offerSelectValue: '1',
      formInline: {
        studentName: '',
        parentPhone: '',
        classroomName: '',
        paySts: '',
        yearCode: '',
        termCode: '',
        createTimeStart: '',
        createTimeEnd: '',
        schoolId: '',
        orgId: '',
        ordTypes: '0'
      }
    };
  },
  created() {
    if (this.portOrg === 2) {
      this.formInline.schoolId = localStorage.getItem('schoolId');
    }
    if (this.$route.query.materialId) {
      this.offerSelectValue = '2';
      this.offerValue = this.$route.query.materialId;
      this.initYear = ['', ''];
    }
  },
  methods: {
    handleSearch() {
      this.$emit('on-search', this.getParameter());
    },
    handleExport() {
      this.$emit('on-export', this.getParameter());
    },
    getParameter() {
      this.formInline.orgId = this.portOrg != 3 ? this.$refs.chooseApplyRef.getResult().orgId : this.userInfo.orgId;
      this.formInline.schoolId = this.portOrg != 2 ? this.$refs.chooseSchoolRef.getResult().orgId : this.userInfo.orgId;
      const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.getResult();
      this.formInline.yearCode = yearTerms[0];
      this.formInline.termCode = yearTerms[1];
      const { createTimeStart, createTimeEnd } = this.formInline;
      return {
        ...this.formInline,
        createTimeStart: createTimeStart || null,
        createTimeEnd: createTimeEnd || null,
        offerName: this.offerSelectValue == 1 ? this.offerValue : '',
        offerId: this.offerSelectValue == 2 ? this.offerValue : '',
        insOrderId: this.orderNumSelectValue == 1 ? this.orderNumValue : '',
        payNo: this.orderNumSelectValue == 2 ? this.orderNumValue : ''
      };
    },
    onCascaderChange(val) {
      this.formInline.yearCode = val[0];
      this.formInline.termCode = val[1];
    },
    onDateChange(date) {
      this.formInline.createTimeStart = date[0];
      this.formInline.createTimeEnd = date[1];
      console.log(date);
    },
    handleReset() {
      this.orderNumValue = '';
      this.orderNumSelectValue = '1';
      this.offerValue = '';
      this.offerSelectValue = '1';
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear();
      this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      for (const k in this.formInline) {
        this.formInline[k] = '';
      }
      this.formInline.ordTypes = '0';
      this.handleSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.search-main {
  margin-bottom: 10px;
}
</style>
